export default __webpack_public_path__ + "static/media/newyork.51273068.jpg";